module.exports = __webpack_public_path__ + "d436f584b5efa8659b6bfc8d06fdb177.svg";